import { type ErrorInfo, type ReactNode, Component } from "react";

import ModuleContext from "~components/modules/module/modulecontext";
import { logError } from "~utils/newrelicBrowser";

interface ErrorBoundaryProps {
    fallback?: ReactNode;
    children: ReactNode;
}

class ErrorBoundary extends Component<ErrorBoundaryProps> {
    state = {
        hasError: false,
    };

    static contextType = ModuleContext;
    declare context: React.ContextType<typeof ModuleContext>;

    static getDerivedStateFromError() {
        return { hasError: true };
    }

    componentDidCatch(error: Error, info: ErrorInfo) {
        const { componentName } = this.context!;
        const url = window?.location?.href || "";
        const msg = `ErrorBoundary error on url: ${url} \n stacktrace: ${info.componentStack} \n In module ${componentName}`;

        logError(error, { msg });
    }

    render() {
        if (this.state.hasError) {
            return this.props.fallback || null;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
